import { gql } from "@/services/httpAdapter";

// Common fragments
import { AddedCompensationFragment, CompensationFragment, ReviewFragment } from "@/Washouts/api/common/fragments";

export function getOnNewFinanceWashoutAvailable() {
	return gql`
		subscription onNewFinanceWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewFinanceWashoutAvailable(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
			) {
				_id
				userId
				commissionCycleId
				payPeriodId
			}
		}
	`;
}

export function getOnUpdateFinanceWashout() {
	return gql`
		subscription onUpdateFinanceWashout($commissionCycleId: String, $payPeriodId: String, $userId: String, $position: String) {
			onUpdateFinanceWashout(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId, position: $position) {
				_id
				commissionCycleId
				payPeriodId
				userId
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
				review {
					...Review
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
}

export function getOnUpdateFinanceWashoutStatus() {
	return gql`
		subscription onUpdateFinanceWashoutStatus($commissionCycleId: String, $payPeriodId: String, $userId: String, $position: String) {
			onUpdateFinanceWashoutStatus(
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				userId: $userId
				position: $position
			) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}
